import type { CrossJoinTargetProduct } from '../../common/types';
import type { PersonalizationResponse } from '../types';

export const isSite7DaysOld = async (
	product: CrossJoinTargetProduct,
	cloudId: string,
): Promise<boolean> => {
	const traitName = ACTIVATION_TRAITS[product] || undefined;
	if (!traitName) {
		throw Error(`Unknown activation trait key for site product ${product}`);
	}
	const siteTraits = await fetchSitePersonalization(cloudId);
	const productActivation = siteTraits.find((trait) => trait.name === traitName);
	if (productActivation?.value) {
		const oneWeekLaterActivation = new Date(productActivation?.value as string);
		oneWeekLaterActivation.setDate(oneWeekLaterActivation.getDate() + 7);
		const today = new Date();
		return today >= oneWeekLaterActivation;
	}
	return false;
};

export const isLoomSite7DaysOld = async (cloudId: string): Promise<boolean> => {
	const traitName = ACTIVATION_TRAITS['loom'] || undefined;
	if (!traitName) {
		throw Error(`Unknown activation trait key for site product Loom}`);
	}
	const siteTraits = await fetchSitePersonalization(cloudId);
	const productActivation = siteTraits.find((trait) => trait.name === traitName);
	if (productActivation?.value) {
		const oneWeekLaterActivation = new Date(productActivation?.value as string);
		oneWeekLaterActivation.setDate(oneWeekLaterActivation.getDate() + 7);
		const today = new Date();
		return today >= oneWeekLaterActivation;
	}
	return true;
};

const ACTIVATION_TRAITS: Record<CrossJoinTargetProduct, string> = {
	'jira-software': 'jira-software.ondemand.activationDate',
	'jira-product-discovery': 'jira-product-discovery.activationDate',
	confluence: 'confluence.ondemand.activationDate',
	loom: 'loom.activationDate',
};

const getPersonalizationSiteTraitsUrl = (cloudId: string) =>
	`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;

const fetchSitePersonalization = async (
	cloudId: string,
): Promise<PersonalizationResponse['attributes']> => {
	const response = await fetch(getPersonalizationSiteTraitsUrl(cloudId), {
		method: 'GET',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
			'x-atlassian-mau-ignore': 'true',
		},
	});

	const { attributes } = await response.json();
	return attributes;
};
